export const baseBackendUrl = process.env.REACT_APP_API_URL